import Vue from "vue";
import axios from "axios";
import config from "@/config";
import Cookies from "js-cookie";
import router from "../router";
import store from "@/store";

export const HTTP = axios.create({
  baseURL: config.MK_API,
  headers: {
    "api-key": "9df4fa08e2ff50268af2856eb34a79276bf51152c8ffaf429371cdf18c79",
  },
});

export const BACKOFFICE = axios.create({
  baseURL: config.MK_BACKOFFICE_API,
  headers: {
    "api-key": "9df4fa08e2ff50268af2856eb34a79276bf51152c8ffaf429371cdf18c79",
  },
});

export const BACKOFFICE_V2 = axios.create({
    baseURL: config.MK_BACKOFFICE_API_V2,
    headers: {
        "api-key": "9df4fa08e2ff50268af2856eb34a79276bf51152c8ffaf429371cdf18c79",
    },
})

BACKOFFICE.interceptors.request.use(
  async function (config) {
    const token = Cookies.get("access");
    const lang = store.state.user.lang.id;
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    if (lang) config.headers.common["Accept-Language"] = lang;
    return config;
  },
  function (err) {
    console.log(err.response);
  }
);

BACKOFFICE_V2.interceptors.request.use(
  async function (config) {
    const token = Cookies.get("access");
    const lang = store.state.user.lang.id;
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    if (lang) config.headers.common["Accept-Language"] = lang;
    return config;
  },
  function (err) {
    console.log(err.response);
  }
);

HTTP.interceptors.request.use(
  async function (config) {
    const token = Cookies.get("access");
    const lang = store.state.user.lang.id;
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      window.location.href =
        "https://backoffice.kodland.org/ru/login/?next=https://booking.kodland.org/";
    }
    if (lang) config.headers.common["Accept-Language"] = lang;
    return config;
  },
  function (err) {
    console.log(err.response);
  }
);

HTTP.interceptors.response.use(
  function (response) {
    return response;
  },
  (error) => {
    console.log(error.response);
    if (error.response.status === 402 || error.response.status === 403) {
      router.push(`/error?code=${error.response.status}`);
    }
    if (error.response.status >= 500) {
      router.push("/error?code=500");
    }
    if (
      error.response.status === 400 ||
      error.response.status === 404 ||
      error.response.status === 409 ||
      error.response.status === 422
    ) {
      Vue.toasted.global.all_mistake(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);
